export type PccAdtRecordType = 'active' | 'cancelled' | 'all';

/**
 * Parameters for fetching ADT records
 * @see https://connect2.pointclickcare.com/api/public/preview1/orgs/{orgUuid}/adt-records
 */
export class PccAdtRecordParams {
	/**
	 * Comma-separated list of ADT record IDs. If provided, patientId/effectiveDate/pageSize should not be used
	 */
	adtRecordIds?: string;

	/**
	 * Required if adtRecordIds is provided
	 */
	facId?: number;

	/**
	 * Date when the ADT records became effective (YYYY-MM-DD)
	 */
	effectiveDate?: string;

	/**
	 * Filter by record type: active, cancelled, or all. Defaults to active
	 */
	recordType?: PccAdtRecordType;
}

/**
 * Represents an ADT (Admission, Discharge, Transfer) record from PointClickCare
 * @see https://connect2.pointclickcare.com/api/public/preview1/orgs/{orgUuid}/adt-records?patientId={patientId}
 */
export class PccAdtRecord {
	/**
	 * PointClickCare's unique identifier for the patient
	 */
	patientId: number;

	/**
	 * Type of admission (e.g., skilled, custodial)
	 */
	admissionType: string;

	/**
	 * Location to which the patient was discharged
	 */
	destination: string;

	/**
	 * Number of days between admission and discharge
	 */
	lengthOfStay: number;

	/**
	 * Represents the standard action type associated to the action type
	 */
	standardActionType: 'Admission' | 'Death' | 'Discharge' | 'Internal Transfer' | 'Leave' | 'Return from Leave' | 'Room Reserve';

	/**
	 * Date when the ADT record became effective
	 */
	effectiveDateTime: string;

	constructor(partial?: Partial<PccAdtRecord>) {
		if (partial) Object.assign(this, partial);
	}
}
